import "./index.css";
import App from "./App";
import { clientEntry } from "@mtfe/conflux-ssr-plugin-react";
import { TrackerProvider } from "@/context/TrackerContext";
import { PageStateProvider } from "@/context/PageStateContext";
import { ToastProvider } from "@/context/ToastContext";
import initVConsole from "@/lib/vconsole";
import { initBridge } from "@/lib/bridge/base";
import locationService, { LocationSource } from "@/lib/location";
import { reportPerfMetric, setOwlTag } from "@/lib/owl";
import { getUserId } from "@/lib/userInfo";
import { APP_VERSION } from "@/lib/constant";
import { getMtAppVersion } from "@/lib/getBrowserEnv";
import { buildCommonInitialState } from './utils/buildInitialState';
import { PAGE_CID } from "@/track/waimai";
import { getUrlParams } from "@/lib/urlParams";
import { OPEN_CITY_ID_LIST } from "./constants";

clientEntry((props: any) => {
  // 上报业务代码开始执行的时间
  window.__CLIENT_ENTRY_START__ = Date.now();
  if (window.__PAGE_JS_START__) {
    reportPerfMetric({
      key: 'pageLoadStart',
      value: window.__CLIENT_ENTRY_START__ - window.__PAGE_JS_START__,
      tags: {
        platform: window.SYSTEM_PLATFORM || '',
        container: window.RUNTIME_CONTAINER || '',
        container_v2: window.RUNTIME_CONTAINER_V2 || '',
        version: APP_VERSION,
        page: '/fx/waimai',
      }
    })
  }
  // 从 _prefetchData 中提取 location 信息（与服务端一致）
  const location = props._prefetchData?.location;
  // 初始化定位信息，传递 SSR 的定位城市和手选城市信息
  locationService.init(location);
  // 初始化桥方法
  initBridge();
  // test/st 环境加载 vconsole
  initVConsole();

  const urlParams = getUrlParams();
  const rcfUniqueId = urlParams.rcf_uniqueid || '';
  // 灵犀埋点上报通参
  const lxContext = {
  };
  // 初始化 Owl Perf 自定义指标 Tag
  setOwlTag({
    userId: getUserId() || '',
    platform: window.SYSTEM_PLATFORM || '',
    container: window.RUNTIME_CONTAINER || '',
    container_v2: window.RUNTIME_CONTAINER_V2 || '',
    version: APP_VERSION,
    mtAppVersion: getMtAppVersion() || '',
    rcfUniqueId,
    // 增加页面维度
    page: '/fx/waimai',
  });
  // 构建 initialState（与服务端一致，使用公共方法）
  const initialState = buildCommonInitialState(props._prefetchData);

  if (initialState) {
    // SSR 预取数据返回，上报页面加载完成耗时
    const navigationStart = performance.timeOrigin;
    if (window?.__PAGE_LVC_TIME__) {
      reportPerfMetric({
        key: 'pageLoadFinished_SSR',
        value: window.__PAGE_LVC_TIME__ - navigationStart,
        tags: {
          locationSource: LocationSource.IP,
        }
      })
      // 上报 SSR 页面加载结束的时间戳
      if (rcfUniqueId) {
        reportPerfMetric({
          key: 'pageLoadFinishedTime_SSR',
          value: window.__PAGE_LVC_TIME__,
        })
      }
    }

    // 上报 SSR 分阶段打点
    const SSR_TIME_RECORD_KEYS = ['locateStartTime', 'locateEndTime', 'locateCost', 'requestStartTime', 'requestEndTime', 'requestCost', 'getServerDataStartTime', 'getServerDataEndTime', 'getServerDataCost'];
    const SSR_TIME_RECORD = props._prefetchData?.SSR_TIME_RECORD || {};
    SSR_TIME_RECORD_KEYS.forEach((key) => {
      if (typeof SSR_TIME_RECORD[key] === 'number') {
        reportPerfMetric({
          key: `SSR_${key}`,
          value: SSR_TIME_RECORD[key],
        })
      }
    })
  }

  return (
    <PageStateProvider
      initialState={initialState}
      openCityIdList={OPEN_CITY_ID_LIST}
    >
      <TrackerProvider cid={PAGE_CID} context={lxContext}>
        <ToastProvider>
          <App {...props} />
        </ToastProvider>
      </TrackerProvider>
    </PageStateProvider>
  );
});
